import { m } from 'framer-motion';
import { Asterisk } from './Ornaments';

/**
 * Section marker: ornament and ordinal on the first line, title on the second.
 *
 * The title takes the hero role line's treatment — uppercase wide-tracked
 * mono — one step up in size and value. Since both lines are then the same
 * kind of object, the gap between them is kept tight (12px) so they group as
 * one heading block, against the 32px that separates the block from its
 * content.
 */
export function SectionHeading({ index, title, isDark }) {
  return (
    <div className="mb-8">
      <m.div
        className="mb-3 flex items-center gap-2.5"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <m.span
          className={`block ${isDark ? 'text-neutral-500' : 'text-neutral-400'}`}
          initial={{ rotate: -60, opacity: 0 }}
          whileInView={{ rotate: 0, opacity: 0.55 }}
          transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1] }}
          viewport={{ once: true }}
        >
          <Asterisk className="h-[11px] w-[11px]" />
        </m.span>
        <span
          className={`u-label transition-colors ${
            isDark ? 'text-neutral-600' : 'text-neutral-400'
          }`}
        >
          {index}
        </span>
      </m.div>

      <m.h2
        className={`u-title text-[0.9375rem] sm:text-[1rem] transition-colors ${
          isDark ? 'text-neutral-100' : 'text-neutral-900'
        }`}
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.05, ease: [0.22, 0.61, 0.36, 1] }}
        viewport={{ once: true }}
      >
        {title}
      </m.h2>
    </div>
  );
}
